import StickyLoyaltyProfileBanner from 'components/ProfileBanner/StickyLoyaltyProfileBanner/StickyLoyaltyProfileBanner';
import { withStickyLoyaltyProfileBannerProps } from 'viewModel/content/BeautyInsider/withStickyLoyaltyProfileBannerProps';

export default withStickyLoyaltyProfileBannerProps(StickyLoyaltyProfileBanner);
